import { createContext } from 'react'

export interface AuthContextValue {
  /** Whether the user is authenticated */
  isAuthenticated: boolean
  /** Whether authentication is in progress */
  isLoading: boolean
  /** Current username (if authenticated) */
  username: string | null
  /** Current auth token (wpcid) */
  token: string | null
  /** Authentication error (if any) */
  error: string | null
  /** Login function */
  login: (username: string, password: string) => Promise<boolean>
  /**
   * Sign in with a session token handed over by an embedding host (`/embed`) instead of a
   * username and password. Resolves false (with `error` set) when the token is rejected.
   */
  adoptSession: (wpcauth: string, username: string) => Promise<boolean>
  /** Logout function */
  logout: () => void
  /** Clear error */
  clearError: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
